if (!customElements.get('wls-product-facet')) {
  class WLSProductFacet extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;

      this.classes = {
        loading: 'loading',
        results: 'wls-product-facet',
      };
    }

    connectedCallback() {
      this.addEventListener('wls:pagination:page-changed', this._onPaginationChange.bind(this));
    }

    disconnectedCallback() {
      this.removeEventListener('wls:pagination:page-changed', this._onPaginationChange);
    }

    async _onPaginationChange(event) {
      const url = new URL(event.detail.url);

      this._abort();
      this._setLoading();

      try {
        this.abortController = new AbortController();
        const res = await fetch(url.toString(), { signal: this.abortController.signal });
        const html = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newFacet = doc.querySelector(`${this.classes.results}`);

        if (newFacet) {
          this.innerHTML = newFacet.innerHTML;
          history.replaceState({}, '', url);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error(error);
        }
      } finally {
        this._removeLoading();
      }
    }

    _abort() {
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }
    }

    _setLoading() {
      this.classList.add(this.classes.loading);
    }

    _removeLoading() {
      this.classList.remove(this.classes.loading);
    }
  }

  customElements.define('wls-product-facet', WLSProductFacet);
}
